export default __webpack_public_path__ + "media/azure_logo.9e8035d5.svg";